export const API_ROUTE_PLEDGES = '/accounts/:accountId/pledges',
  API_ROUTE_PLEDGE = '/accounts/:accountId/pledges/:pledgeId',
  API_ROUTE_PRODUCTS_GLOBAL = '/products/global/search',
  API_ROUTE_SUBSCRIPTION_FILE = '/accounts/:accountId/documents/:documentId',
  API_ROUTE_SEND_ELECTRONIC =
    '/accounts/:accountId/pledges/:id/sendElectronicSignature',
  API_ROUTE_PRODUCTS = '/products/search',
  API_ROUTE_PRODUCT = '/products/:id',
  API_ROUTE_SEND_ELECTRONIC_SIGNATURE = `/pledges/:pledgeId/sendElectronicSignature`,
  API_ROUTE_SEND_PAPER_SIGNATURE = `/pledges/:pledgeId/send-paper-signature`,
  API_ROUTE_IDENTITY_DOCUMENTS_VERIFY =
    '/accounts/:accountId/documents/user/:userId/documents/hasIdentityDocumentsUniversignVerify',
  API_ROUTE_DOCUMENT = '/accounts/:accountId/documents/:documentId',
  API_GRIDKY_SEARCH = '/gridky/properties/search',
  API_ROUTE_SUPPORTS_SEARCH = '/supports/search';
